import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class LiquidityUtilisationLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public investorInvestmentId: number = 0;

    public investmentId: number = 0;

    @Attributes.Float()
    public maxHoldingPercent: number = 0;

    @Attributes.Integer()
    public buyPriority: number = 0;

    @Attributes.Integer()
    public sellPriority: number = 0;

    @Attributes.Float()
    public liquidityBalance: number = 0;

    @Attributes.Float()
    public capitalBalance: number = 0;

    // Client only properties / methods

    /** Returns the liquidity providers total balance. */
    public get balance() {
        return this.liquidityBalance + this.capitalBalance;
    }
}